const allDataLifestyle = {
    categoryComp : {
        categoryComp1: {
            lgUrl:"https://assets2.razerzone.com/images/pnx.assets/0666dc773bd5460ed41bf6e1a1ebad3a/lifestyle-chairs-category-banner.jpg",
            mdUrl:"https://assets2.razerzone.com/images/pnx.assets/0666dc773bd5460ed41bf6e1a1ebad3a/lifestyle-chairs-category-banner-mobile.jpg",
            title:"CHAIRS",
            des:"Discover the support you need to power through gaming marathons.",
            lUrl:"/"
        },
        categoryComp2: {
            lgUrl:"https://assets2.razerzone.com/images/pnx.assets/f016346e8c8e71ae1ad6731d95943a86/sneki-snek-s2-desktop-cat-banner.jpg",
            mdUrl:"https://assets2.razerzone.com/images/pnx.assets/f016346e8c8e71ae1ad6731d95943a86/sneki-snek-s2-450x480-mobile-cat-banner.jpg",
            title:"SNEKI SNEK ANIMATION SERIES",
            des:"Can’t get enough of our adorable cutie? Catch Sneki Snek and friends in an all-new season as they continue to show why sustainability is important!",
            lUrl:"/"
        },
        categoryComp3: {
            lgUrl:"https://assets2.razerzone.com/images/pnx.assets/5044606f04fbcc28b98ca2be9b48bc3e/services-gold-pins.jpg",
            mdUrl:"https://assets2.razerzone.com/images/pnx.assets/5044606f04fbcc28b98ca2be9b48bc3e/razer-goldpin-768x500-mobile.jpg",
            title:"COMPLETE YOUR SETUP",
            des:"A Color For Every Style",
        },
        categoryComp4: {
          lgUrl:"https://assets2.razerzone.com/images/pnx.assets/c44ce6aa9d981f08ce3f054e20fa07b2/services-gold-webshop.jpg",
          mdUrl:"https://assets2.razerzone.com/images/pnx.assets/c44ce6aa9d981f08ce3f054e20fa07b2/razer-webshop-768x500-mobile.jpg",
          title:"GOLD WEBSHOP",
          des:"Browse over 42,000 games and entertainment titles in the Gold Webshop. <br/> Recharge on the hottest titles such as PUBG Mobile, Mobile Legends: Bang Bang, Genshin Impact, and many more! Check out our Gold Webshop for the full list of titles.",
          lUrl:"/"
        },
        categoryComp5: {
        lgUrl:"https://assets2.razerzone.com/images/pnx.assets/c126593c168b557f2d7f3f0f596f4364/services-gift-card.jpg",
        mdUrl:"https://assets2.razerzone.com/images/pnx.assets/c126593c168b557f2d7f3f0f596f4364/services-gift-card-mobile.jpg",
        title:"RAZER GIFT CARD - GIVE THE GIFT OF GAMING",
        des:"The Razer Gift Card unlocks the ultimate gifts for any gamer. From gaming peripherals to laptops to apparel, redeem from the largest catalog of Razer gear in the world, including rare and exclusive products only found on Razer.com. Recipients also enjoy 14-day risk free returns, and comprehensive customer support.",
        lUrl:"/"
        },
        categoryComp6: {
      lgUrl:"https://assets2.razerzone.com/images/pnx.assets/cd51cc9a2c8e89918bcce4a6b66132d3/services-razer-care.jpg",
      mdUrl:"https://assets2.razerzone.com/images/pnx.assets/cd51cc9a2c8e89918bcce4a6b66132d3/razer-care-768x500-mobile.jpg",
      title:"RAZERCARE",
      des:"Protect your Razer gear with RazerCare—includes extended warranty that covers both mechanical and electrical issues due to normal product usage.",
      lUrl:"/"
      },
      categoryComp7: {
      lgUrl:"https://assets2.razerzone.com/images/pnx.assets/5650df732c97f6ce9e0c813fc57b9605/services-razer-id.jpg",
      mdUrl:"https://assets2.razerzone.com/images/pnx.assets/5650df732c97f6ce9e0c813fc57b9605/services-razer-id.jpg",
      title:"RAZER ID",
      des:"Gain a competitive advantage and leverage on our support, expertise and community with your Razer ID. Integrated with Razer's services and software, you can gain access to tons of tools with your Razer ID—including buying the best gamer gear on our site, redeeming Razer Silver, saving your personalized configs in Synapse, and more.",
      lUrl:"/"
      },
      categoryComp8: {
        lgUrl:"https://assets2.razerzone.com/images/pnx.assets/5650df732c97f6ce9e0c813fc57b9605/services-razer-id.jpg",
        mdUrl:"https://assets2.razerzone.com/images/pnx.assets/5650df732c97f6ce9e0c813fc57b9605/services-razer-id.jpg",
        title:"RAZER ID",
        des:"Gain a competitive advantage and leverage on our support, expertise and community with your Razer ID. Integrated with Razer's services and software, you can gain access to tons of tools with your Razer ID—including buying the best gamer gear on our site, redeeming Razer Silver, saving your personalized configs in Synapse, and more.",
        lUrl:"/"
        },
        categoryComp9: {
          lgUrl:"https://assets2.razerzone.com/images/pnx.assets/5650df732c97f6ce9e0c813fc57b9605/services-razer-id.jpg",
          mdUrl:"https://assets2.razerzone.com/images/pnx.assets/5650df732c97f6ce9e0c813fc57b9605/services-razer-id.jpg",
          title:"RAZER ID",
          des:"Gain a competitive advantage and leverage on our support, expertise and community with your Razer ID. Integrated with Razer's services and software, you can gain access to tons of tools with your Razer ID—including buying the best gamer gear on our site, redeeming Razer Silver, saving your personalized configs in Synapse, and more.",
          lUrl:"/"
          },
          categoryComp10: {
            lgUrl:"https://assets2.razerzone.com/images/pnx.assets/5650df732c97f6ce9e0c813fc57b9605/services-razer-id.jpg",
            mdUrl:"https://assets2.razerzone.com/images/pnx.assets/5650df732c97f6ce9e0c813fc57b9605/services-razer-id.jpg",
            title:"RAZER ID",
            des:"Gain a competitive advantage and leverage on our support, expertise and community with your Razer ID. Integrated with Razer's services and software, you can gain access to tons of tools with your Razer ID—including buying the best gamer gear on our site, redeeming Razer Silver, saving your personalized configs in Synapse, and more.",
            lUrl:"/"
            },
    },
    topDrawer : {
      data1 : [
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-chairs.svg",
        title: "Chairs",
        link: "/",
      },
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-watch.svg",
        title: "Wearables",
        link: "/",
      },
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-apparel.svg",
        title: "Apparel",
        link: "/pc",
      },
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-bags.svg",
        title: "Bags",
        link: "/console",
      },
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-gear.svg",
        title: "Gear",
        link: "/",
      },
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-razercare.svg",
        title: "Sneki Snek",
        link: "/",
      },
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-respawn.svg",
        title: "RESPAWN",
        link: "/",
      },
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-customs-v2.svg",
        title: "Customs",
        link: "/",
      },
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-collabs.svg",
        title: "Collabs",
        link: "/",
      },
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-book13.svg",
        title: "Book",
        link: "/",
      },
      {
        img: "https://assets2.razerzone.com/images/main-menu/icons/icon-mac.svg",
        title: "Mac",
        link: "/",
      },
    ],
  }
}


export default allDataLifestyle